import { render, staticRenderFns } from "./DedicatedFundListDedicatedFundInfoCard.vue?vue&type=template&id=206df4c4"
import script from "./DedicatedFundListDedicatedFundInfoCard.vue?vue&type=script&lang=js"
export * from "./DedicatedFundListDedicatedFundInfoCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports